<style scoped>
/* Base container with modern design */
.result-container {
  background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
  border-radius: 20px;
  box-shadow: 
    0 10px 40px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(255, 196, 3, 0.1);
  max-width: 650px;
  margin: 2rem auto;
  padding: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.result-container:hover {
  box-shadow: 
    0 15px 50px rgba(0, 0, 0, 0.12),
    0 0 0 1px rgba(255, 196, 3, 0.2);
}

/* Header section with improved gradient */
.header-section {
  background: linear-gradient(135deg, #FFC403 0%, #FFD700 50%, #000000 100%);
  padding: 2.5rem 2rem;
  text-align: center;
  color: #000;
  position: relative;
  overflow: hidden;
}

.header-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
}

.header-section h1,
.header-section h2,
.header-section h3,
.header-section h4 {
  font-family: 'MTNBrighterSans', sans-serif;
  color: #000;
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 1;
}

.logos-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.ministry-logo,
.mtn-logo {
  height: 10rem;
  width: auto;
  max-width: 45%;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}

.ministry-logo:hover,
.mtn-logo:hover {
  transform: scale(1.05);
}

/* Content section */
.content-section {
  padding: 2rem;
}

.student-info {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid rgba(255, 196, 3, 0.15);
  position: relative;
  overflow: hidden;
}

.student-info::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(to bottom, #FFC403, #FFD700);
  border-radius: 0 4px 4px 0;
}

/* Modern table design */
.result-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 0.75rem;
  direction: rtl;
}

.result-row {
  background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  overflow: hidden;
}

.result-row:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 196, 3, 0.15);
}

.result-row td {
  padding: 1.25rem;
  border: none;
  font-size: 1.1rem;
  line-height: 1.5;
}

.result-row td:first-child {
  border-radius: 12px 0 0 12px;
}

.result-row td:last-child {
  border-radius: 0 12px 12px 0;
}

.label-cell {
  background: linear-gradient(90deg, #fff9e6 0%, #ffffff 100%);
  color: #333;
  font-weight: 700;
  width: 35%;
  position: relative;
  border-left: 4px solid #FFC403;
}

.value-cell {
  color: #444;
  font-weight: 600;
  width: 65%;
  word-break: break-word;
}

/* Status styling */
.status-success {
  color: #22c55e;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(34, 197, 94, 0.2);
}

.status-info {
  color: #3b82f6;
  font-weight: 700;
}

.status-warning {
  color: #f59e0b;
  font-weight: 700;
}

/* Action buttons */
.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2.5rem;
  flex-wrap: wrap;
}

.btn-modern {
  padding: 0.875rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  min-width: 160px;
}

.btn-modern::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.btn-modern:hover::before {
  left: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, #FFC403 0%, #FFD700 100%);
  color: #000;
  box-shadow: 0 4px 15px rgba(255, 196, 3, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 196, 3, 0.4);
}

.btn-secondary {
  background: transparent;
  border: 2px solid #FFC403;
  color: #333;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #FFC403 0%, #FFD700 100%);
  color: #000;
  transform: translateY(-2px);
}

/* Loading and error states */
.loading-state,
.error-state {
  text-align: center;
  padding: 3rem 2rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #FFC403;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-alert {
  background: linear-gradient(135deg, #fef2f2 0%, #fff 100%);
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 1.5rem;
  color: #dc2626;
  margin-bottom: 1rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .result-container {
    margin: 1rem;
    border-radius: 16px;
  }

  .header-section {
    padding: 1.5rem 1rem;
  }

  .content-section {
    padding: 1.5rem;
  }

  .logos-container {
    gap: 1.5rem;
    margin-bottom: 1rem;
  }

  .ministry-logo,
  .mtn-logo {
    height: 9rem;
    max-width: 40%;
  }

  .header-section h1 {
    font-size: 1.5rem;
  }

  .header-section h2 {
    font-size: 1.2rem;
  }

  .header-section h3,
  .header-section h4 {
    font-size: 1rem;
  }

  .student-info {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }

  .result-row td {
    padding: 1rem;
    font-size: 1rem;
  }

  .action-buttons {
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 2rem;
  }

  .btn-modern {
    width: 100%;
    min-width: auto;
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .result-container {
    margin: 0.5rem;
    border-radius: 12px;
  }

  .header-section {
    padding: 1rem;
  }

  .content-section {
    padding: 1rem;
  }

  .logos-container {
    flex-direction: column;
    gap: 1rem;
  }

  .ministry-logo,
  .mtn-logo {
    height: 9rem;
    max-width: 60%;
  }

  .result-row td {
    padding: 0.75rem;
    font-size: 0.9rem;
  }

  .label-cell {
    width: 40%;
  }

  .value-cell {
    width: 60%;
  }
}
</style>

<script setup>
import { ref, onMounted, computed, defineProps } from 'vue'
import { useRouter } from 'vue-router'
import html2pdf from 'html2pdf.js'
import mtnLogo from '../assets/mtn.png'
// import ministryLogo from '../assets/logo.png'

// Props
const props = defineProps({
  result: {
    type: Object,
    default: null
  }
})

// Composables
const router = useRouter()

// Reactive data
const studentResult = ref(null)
const isLoading = ref(true)
const error = ref(null)

// Computed properties
const hasResult = computed(() => studentResult.value !== null)
const seatNumber = computed(() => studentResult.value?.seatNumber || '')
const resultText = computed(() => studentResult.value?.result || '')

// Methods
const loadResult = () => {
  try {
    // Try to get result from props first
    if (props.result) {
      studentResult.value = props.result
      return true
    }

    // Try to get from sessionStorage
    const stored = sessionStorage.getItem('student_result')
    if (stored) {
      studentResult.value = JSON.parse(stored)
      return true
    }

    return false
  } catch (e) {
    console.error('Error loading result:', e)
    error.value = 'حدث خطأ في تحميل النتيجة'
    return false
  }
}

const handleBack = () => {
  router.push({ name: 'home' })
}

const exportToPDF = async () => {
  const element = document.querySelector('.result-container')
  if (!element) {
    error.value = 'لا يمكن تصدير النتيجة'
    return
  }

  try {
    const opt = {
      margin: 0.5,
      filename: `result-${seatNumber.value || 'unknown'}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        imageTimeout: 0,
        logging: false
      },
      jsPDF: { 
        unit: 'in', 
        format: 'a4', 
        orientation: 'portrait',
        compress: true
      }
    }

    await html2pdf().set(opt).from(element).save()
  } catch (error) {
    console.error('PDF Export error:', error)
    error.value = 'فشل في تصدير ملف PDF'
  }
}

// Lifecycle
onMounted(() => {
  const loaded = loadResult()
  
  if (!loaded) {
    error.value = 'لم يتم العثور على نتيجة'
    setTimeout(() => {
      router.push({ name: 'home' })
    }, 3000)
  }
  
  isLoading.value = false
})
</script>

<template>
  <div class="font-arabic result-container">
    <!-- Header Section -->
    <header class="header-section">
      <div class="logos-container">
        <!-- <img 
          :src="ministryLogo" 
          alt="شعار وزارة التعليم" 
          class="ministry-logo"
          loading="lazy"
        /> -->
        <img 
          :src="mtnLogo" 
          alt="شعار إم تي إن" 
          class="mtn-logo"
          loading="lazy"
        />
      </div>
      
      <div class="header-text">
        <!-- <h1 class="fs-2 fw-bold">جمهورية السودان</h1>
        <h2 class="fs-4 fw-semibold">وزارة التعليم العالي والبحث العلمي</h2>
        <h3 class="fs-5">نتيجة القبول للجامعات السودانية</h3>
        <h4 class="fs-6 text-muted">لعام 2025</h4> -->

           <h3 class="fs-5">نتيجة القبول العام للجامعات السودانية </h3>
        <h4 class="fs-6">للعام 2023 المؤجل</h4>
      </div>
    </header>

    <!-- Content Section -->
    <main class="content-section">
      <!-- Loading State -->
      <div v-if="isLoading" class="loading-state">
        <div class="loading-spinner"></div>
        <p class="fs-5">جاري تحميل النتيجة...</p>
      </div>

      <!-- Error State -->
      <div v-else-if="error" class="error-state">
        <div class="error-alert">
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button @click="handleBack" class="btn-modern btn-secondary">
          <i class="fas fa-home me-2"></i>
          عودة للصفحة الرئيسية
        </button>
      </div>

      <!-- Result Content -->
      <div v-else-if="hasResult" class="result-content">
        <!-- Student Info Section -->
        <section class="student-info">
          <h3 class="h5 mb-3 text-center fw-bold">
            <i class="fas fa-user-graduate me-2"></i>
            معلومات النتيجة
          </h3>
        </section>

        <!-- Result Table -->
        <div class="table-container">
          <table class="result-table">
            <tbody>
              <tr class="result-row">
                <td class="label-cell">
                  <i class="fas fa-id-card me-2"></i>
                  رقم الجلوس
                </td>
                <td class="value-cell">{{ seatNumber }}</td>
              </tr>
              
              <tr class="result-row">
                <td class="label-cell">
                  <i class="fas fa-graduation-cap me-2"></i>
                  النتيجة
                </td>
                <td class="value-cell" :class="{
                  'status-success': resultText.includes('كلي'),
                  'status-info': resultText.includes('جامعة'),
                  'status-warning': !resultText.includes('كلي') && !resultText.includes('جامعة')
                }">
                  {{ resultText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <button @click="exportToPDF" class="btn-modern btn-primary">
            <i class="fas fa-file-pdf me-2"></i>
            تحميل PDF
          </button>
          <button @click="handleBack" class="btn-modern btn-secondary">
            <i class="fas fa-home me-2"></i>
            عودة للصفحة الرئيسية
          </button>
        </div>
      </div>

      <!-- No Result State -->
      <div v-else class="error-state">
        <div class="error-alert">
          <i class="fas fa-search me-2"></i>
          لا توجد نتيجة للعرض
        </div>
        <p class="text-muted mb-3">سيتم توجيهك للصفحة الرئيسية...</p>
        <button @click="handleBack" class="btn-modern btn-secondary">
          <i class="fas fa-home me-2"></i>
          عودة للصفحة الرئيسية
        </button>
      </div>
    </main>
  </div>
</template>